const useSharedStyles = {
  overflowText: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  fullWidth: { width: '100%' },
  centerContent: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  centerContentHorizontal: {
    justifyContent: 'center',
  },
  centerContentVertical: {
    alignItems: 'center',
  },
  italicText: { fontStyle: 'italic' },
  secondaryText: { color: 'text.secondary' },
}
export default useSharedStyles
